<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div v-show="ui.step === 'acceuil'">
      <p class="ContextBlockSpec">
        <b style="font-size: 19px">Où en est votre défi ?</b> Il y a 3 jours, vous avez pris la résolution de consommer moins de produits gras et sucrés. Avez-vous tenu votre engagement ?
      </p>

      <p class="ObjectiveBlockSpec">
        <b class="primary--text">Objectif : </b>
        Réduire sa consommation quotidienne de produits gras et sucrés
      </p>

      <div class="InstructionsBlockSpec">
        Pour réaliser cette mission, vous devez :<br/>
        <ol>
          <li>Répondre au quiz</li>
          <li>VALIDER la mission</li>
        </ol>
      </div>

      <v-btn block
             large
             rounded
             @click="step('question')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'question'">
      <h3 class="primary--text"><b>Consommer moins de produits gras et sucrés</b></h3>

      <span class="Question">Le défi consistait à faire la chasse aux excès <span class="primary--text">de matières grasses et de sucre</span> (en lisant bien les étiquettes), favoriser la consommation de poisson et privilégier la consommation de fruits et légumes en remplacement.</span>

      <p class="Question">
        Avez-vous réussi votre défi ?
      </p>

      <v-btn block
             large
             rounded
             @click="step('oui')"
             class="primary mt-10 mb-4">Oui
      </v-btn>
      <v-btn block
             large
             rounded
             @click="step('non')"
             class="primary mt-10 mb-4">Non
      </v-btn>
    </div>

    <div v-show="ui.step === 'non'">
      <p class="Question">Dommage… Pouvez-vous nous indiquer pourquoi vous n’avez pas réussi votre défi ?</p>

      <v-radio-group v-model="missionData.quiz.pourquoi">
        <v-radio :value="0" label="je n’ai pas eu le temps, pas envie de le faire…"></v-radio>
        <v-radio :value="1" label="j’ai eu trop faim"></v-radio>
        <v-radio :value="2" label="j’ai du mal à me passer de sucre… c’est raté"></v-radio>
        <v-radio :value="3" label="j’aime trop le beurre, la crème, les charcuteries…"></v-radio>
      </v-radio-group>

      <v-btn block
             large
             rounded
             :disabled="this.missionData.quiz.pourquoi === null"
             @click="step('commentaire')"
             class="primary mt-10 mb-4">Allons-y !
      </v-btn>
    </div>

    <div v-show="ui.step === 'commentaire'">
      <div class="Info" v-if="missionData.quiz.pourquoi === 0">
        Vous pourrez refaire ce défi une autre fois ou en choisir un autre, n’abandonnez pas !
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 1">
        Peut-être que vous ne mangez pas assez en quantité quand il s’agit de légumes… Vous pouvez aussi atteindre la satiété en ajoutant de petites collations entre les repas, à base de compotes, fruit, petit sandwich. N’oubliez pas que, contrairement à ce que l’on croit, les sucreries calent sur le moment mais provoquent des fringales très vite après.
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 2">
        Si vous avez une appétence au sucre difficile à contenir, utilisez (modérément et transitoirement) des édulcorants pour vous aider (sucralose, stévia, aspartame..). Mais en même temps réduisez progressivement, sur plusieurs semaines votre consommation de sucres ou édulcorants. Tout est une question d’habitude, si vous réduisez doucement en économisant ici et là, un sucre de moins dans le café, une sucrerie refusée, un dessert sauté… vous finirez par ne plus avoir envie de sucre !
      </div>
      <div class="Info" v-else-if="missionData.quiz.pourquoi === 3">
        Vous n’êtes pas obligé.e de supprimer le beurre ou la crème, réduisez les quantités simplement. Les matières grasses sont nécessaires et ne doivent pas être éliminées, mais leur consommation mieux contrôlée. Choisissez des charcuteries maigres, mangez de la viande volaille plus souvent, n’oubliez pas les œufs… et utilisez les huiles de colza et olive ou noix !
      </div>

      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'oui'">
      <div class="Info">
        <p>Bravo ! Vous avez relevé le défi avec succès.</p>
        <p>Lire les étiquettes des aliments industriels est un bon réflexe à acquérir. Mieux, les remplacer par des produits frais et locaux, de saison, éviter les sucreries, limiter la consommation de matières grasses comme le beurre et la crème, et favoriser les huiles de colza ou d’olive : voilà de bonnes idées santé !</p>
      </div>

      <v-btn block
             large
             rounded
             @click="step('fin')"
             class="primary mt-10 mb-4">Fin
      </v-btn>
    </div>

    <div v-show="ui.step === 'fin'">
      <div class="Info">
        Merci d'avoir répondu à ce questionnaire.<br/>
        Vous pourrez retrouver l'analyse de vos réponses dans votre médiathèque.
      </div>

      <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour valider et enregistrer ce questionnaire</p>

      <FinishMissionButtonBlock class="mt-10"
                                @click.native="finishMission">Valider la mission
      </FinishMissionButtonBlock>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'

  export default {
    components: {
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            question: null,
            pourquoi: null
          }
        },
        ui: {
          step: 'acceuil'
        }
      }
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.updateData(target);
        this.ui.step = target;
      },

      updateData(target) {
        switch (target) {
          case 'oui':
            this.missionData.quiz.question = true;
            break;
          case 'non':
            this.missionData.quiz.question = false;
            break;
        }
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
